module.exports = [{"type":"title","text":"2025-12-18"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Upgraded the futures demo VST claim endpoint from v1 to v2(/openApi/swap/v2/trade/getVst), adding support for increasing or decreasing custom amounts."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-12-18.json
// module id = sqvz
// module chunks = 3